import {
  // GET_SERVICES_SUCCESS,
  // GET_SERVICES_FAIL,
  // GET_SERVICES,
  POST_CLOUD_ONBOARDING,
  POST_CLOUD_ONBOARDING_FAIL,
  POST_GCP_ONBOARDING,
  POST_GCP_ONBOARDING_FAIL,
  POST_AZURE_ONBOARDING_FAIL,
  POST_AZURE_ONBOARDING,
  POST_ONBOARD_ALERT,
  POST_DATADOG_ONBOARDING,
  POST_DATADOG_ONBOARDING_FAIL,
  TEST_AWS_CONNECTION_FAIL,
  TEST_AWS_CONNECTION_SUCCESS,
  TEST_AZURE_CONNECTION_FAIL,
  TEST_AZURE_CONNECTION_SUCCESS,
  TEST_GCP_CONNECTION_FAIL,
  TEST_GCP_CONNECTION_SUCCESS,
  TEST_AWS_CONNECTION,
  TEST_GCP_CONNECTION,
  TEST_AZURE_CONNECTION,
  POST_SPLUNK_ONBOARDING,
  POST_SPLUNK_ONBOARDING_FAIL,
  POST_APP_DYNAMICS_ONBOARDING_FAIL,
  POST_APP_DYNAMICS_ONBOARDING,
  POST_DYNATRACE_ONBOARDING_SUCCESS,
  POST_DYNATRACE_ONBOARDING_FAIL,
  POST_DYNATRACE_ONBOARDING,
  GET_ALL_AWS_ACCOUNTS,
  GET_ALL_AWS_ACCOUNTS_SUCCESS,
  DELETE_AWS_ACCOUNT_SUCCESS,
  GET_ENCRYPTED_ORG_ID_SUCCESS,
  TEST_OCI_CONNECTION,
  TEST_OCI_CONNECTION_SUCCESS,
  TEST_OCI_CONNECTION_FAIL,
  TEST_SENTRY_CONNECTION,
  TEST_SENTRY_CONNECTION_SUCCESS,
  TEST_SENTRY_CONNECTION_FAIL,
  RESET_SENTRY_STATES,
  TEST_LOKI_CONNECTION,
  TEST_LOKI_CONNECTION_FAIL,
  TEST_LOKI_CONNECTION_SUCCESS,
  RESET_LOKI_STATES,
  TEST_CORALOGIX_CONNECTION,
  TEST_CORALOGIX_CONNECTION_FAIL,
  TEST_CORALOGIX_CONNECTION_SUCCESS,
  RESET_CORALOGIX_STATES,
  GET_ALL_AZURE_ACCOUNTS_SUCCESS,
  GET_ALL_GCP_PROJECTS_SUCCESS,
  GET_ALL_NEW_RELIC_ACCOUNTS,
  GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS,
  DELETE_NEW_RELIC_ACCOUNT_SUCCESS,
  TEST_SIGNOZ_CONNECTION_SUCCESS,
  TEST_SIGNOZ_CONNECTION_FAIL, TEST_SIGNOZ_CONNECTION,
} from "./actionTypes";

const INIT_STATE = {
  services: [],
  cloud_onboarding: [],
  cloud_onboarding_error: [],
  gcp_onboarding: [],
  gcp_onboarding_error: [],
  azure_onboarding: [],
  azure_onboarding_error: [],
  datadog_onboarding: [],
  datadog_onboarding_error: [],
  test_aws_connection: [],
  test_gcp_connection: [],
  test_azure_connection: [],
  test_signoz_connection: [],
  test_oci_connection: [],
  test_sentry_connection: [],
  test_loki_connection: [],
  test_coralogix_connection: [],
  splunk_onboarding: [],
  splunk_onboarding_error: [],
  is_azure_verifying: false,
  is_signoz_verifying: false,
  is_gcp_verifying: false,
  is_aws_verifying: false,
  is_oci_verifying: false,
  is_sentry_verifying: false,
  is_loki_verifying: false,
  is_coralogix_verifying: false,
  error: [],
  appdynamics_onboarding: [],
  dynatrace_onboarding: [],
  aws_accounts: [],
  new_relic_account: [],
  azure_account: {},
  gcp_projects: [],
  encrypted_org_id: {
      aws_account_id: "",
      encrypted_org_id: ""
  }
};

const Onboarding = (state = INIT_STATE, action) => {
  switch (action.type) {
    // case GET_SERVICES_SUCCESS:
    //   return {
    //     ...state,
    //     services: action.payload,
    //   }
    //
    // case GET_SERVICES_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    case POST_CLOUD_ONBOARDING:
      return {
        ...state,
        cloud_onboarding: action.payload,
      }

    case POST_CLOUD_ONBOARDING_FAIL:
      return {
        ...state,
        cloud_onboarding_error: action.payload,
      }

    case POST_GCP_ONBOARDING:
      return {
        ...state,
        gcp_onboarding: action.payload,
      }

    case POST_GCP_ONBOARDING_FAIL:
      return {
        ...state,
        gcp_onboarding_error: action.payload,
      }

    case POST_AZURE_ONBOARDING:
      return {
        ...state,
        azure_onboarding: action.payload,
      }
    case POST_AZURE_ONBOARDING_FAIL:
      return {
        ...state,
        azure_onboarding_error: action.payload,
      }

    case POST_SPLUNK_ONBOARDING:
        return {
            ...state,
            splunk_onboarding: action.payload,
        }

    case POST_SPLUNK_ONBOARDING_FAIL:
        return {
            ...state,
            splunk_onboarding_error: action.payload,
        }

     case POST_DATADOG_ONBOARDING:
        return {
            ...state,
            datadog_onboarding: action.payload,
        }

    case POST_DATADOG_ONBOARDING_FAIL:
      return {
        ...state,
        datadog_onboarding_error: action.payload,
      }

    case TEST_AWS_CONNECTION_SUCCESS:
        return {
            ...state,
            test_aws_connection: action.payload,
            is_aws_verifying: false
        }
    case TEST_AWS_CONNECTION_FAIL:
        return {
            ...state,
          error: action.payload,
          is_aws_verifying: false
        }
    case TEST_GCP_CONNECTION_SUCCESS:
        return {
            ...state,
            test_gcp_connection: action.payload,
            is_gcp_verifying: false
        }
    case TEST_GCP_CONNECTION_FAIL:
        return {
            ...state,
          error: action.payload,
          is_gcp_verifying: false
        }
    case TEST_AZURE_CONNECTION_SUCCESS:
        return {
            ...state,
            test_azure_connection: action.payload,
            is_azure_verifying: false
        }
    case TEST_AZURE_CONNECTION_FAIL:
        return {
            ...state,
          error: action.payload,
          is_azure_verifying: false
        }
    case TEST_SIGNOZ_CONNECTION:
      return {
        ...state,
        is_signoz_verifying: true,
      }
    case TEST_SIGNOZ_CONNECTION_SUCCESS:
      return {
        ...state,
        test_signoz_connection: action.payload,
        is_signoz_verifying: false
      }
    case TEST_SIGNOZ_CONNECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        is_signoz_verifying: false
      }
    case TEST_AWS_CONNECTION:
        return {
            ...state,
            is_aws_verifying: true,
        }
    case TEST_GCP_CONNECTION:
            return {
                ...state,
                is_gcp_verifying: true,
            }
    case TEST_AZURE_CONNECTION:
        return {
            ...state,
            is_azure_verifying: true,
        }

    case POST_APP_DYNAMICS_ONBOARDING:
        return {
            ...state,
            appdynamics_onboarding: action.payload,
        }

    case POST_APP_DYNAMICS_ONBOARDING_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case POST_DYNATRACE_ONBOARDING:
        return {
            ...state,
            dynatrace_onboarding: action.payload,
        }
    case POST_DYNATRACE_ONBOARDING_FAIL:
        return {
            ...state,
            error: action.payload,
        }
    case GET_ALL_AWS_ACCOUNTS:
        return {
            ...state,
            error: action.payload,
        }
    case GET_ALL_AWS_ACCOUNTS_SUCCESS:
        return {
            ...state,
            aws_accounts: action.payload,
        }
    case GET_ALL_AZURE_ACCOUNTS_SUCCESS:
        return {
            ...state,
            azure_account: action.payload,
        }
    case DELETE_AWS_ACCOUNT_SUCCESS:
        return {
            ...state,
            aws_accounts: action.payload,
        }
    case DELETE_NEW_RELIC_ACCOUNT_SUCCESS:
      return {
        ...state,
        new_relic_account: action.payload,
      }
    case GET_ENCRYPTED_ORG_ID_SUCCESS:
        return {
            ...state,
            encrypted_org_id: action.payload,
        }
    case TEST_OCI_CONNECTION:
      return {
        ...state,
        is_oci_verifying: true,
      }
    case TEST_OCI_CONNECTION_SUCCESS:
      return {
        ...state,
        test_oci_connection: action.payload,
        is_oci_verifying: false
      }
    case TEST_OCI_CONNECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        is_oci_verifying: false
      }
    case TEST_SENTRY_CONNECTION:
      return {
        ...state,
        is_sentry_verifying: true,
      }
    case TEST_SENTRY_CONNECTION_SUCCESS:
      return {
        ...state,
        test_sentry_connection: action.payload,
        is_sentry_verifying: false
      }
    case TEST_SENTRY_CONNECTION_FAIL:
      return {
        ...state,
        error: action.payload,
        is_sentry_verifying: false
      }
      case RESET_SENTRY_STATES:
        return {
          ...state,
          test_sentry_connection: [],
          is_sentry_verifying: false
        }
      case TEST_LOKI_CONNECTION:
        return {
          ...state,
          is_loki_verifying: true,
        }
      case TEST_LOKI_CONNECTION_SUCCESS:
        return {
          ...state,
          test_loki_connection: action.payload,
          is_loki_verifying: false
        }
      case TEST_LOKI_CONNECTION_FAIL:
        return {
          ...state,
          error: action.payload,
          is_loki_verifying: false
        }
      case RESET_LOKI_STATES:
        return {
          ...state,
          test_loki_connection: [],
          is_loki_verifying: false
        }
      case TEST_CORALOGIX_CONNECTION:
        return {
          ...state,
          is_coralogix_verifying: true,
        }
      case TEST_CORALOGIX_CONNECTION_SUCCESS:
        return {
          ...state,
          test_coralogix_connection: action.payload,
          is_coralogix_verifying: false
        }
      case TEST_CORALOGIX_CONNECTION_FAIL:
        return {
          ...state,
          error: action.payload,
          is_coralogix_verifying: false
        }
      case RESET_CORALOGIX_STATES:
        return {
          ...state,
          test_coralogix_connection: [],
          is_coralogix_verifying: false
        }
      case GET_ALL_GCP_PROJECTS_SUCCESS:
          return {
              ...state,
              gcp_projects: action.payload,
          }
      case GET_ALL_NEW_RELIC_ACCOUNTS:
        return {
          ...state,
          error: action.payload,
        }
      case GET_ALL_NEW_RELIC_ACCOUNTS_SUCCESS:
        return {
          ...state,
          new_relic_account: action.payload,
        }
    default:
      return state
  }
}


export default Onboarding;